export default __webpack_public_path__ + "static/media/pexels-daniel-reche-1556716.f88dd22f.jpg";